function isLocalhost(hostname: string): boolean {
  return hostname === "localhost" || hostname === "127.0.0.1" ||
    hostname === "[::1]";
}

function requirePublicConfig(): {
  supabaseUrl: string;
  publishableKey: string;
  environment: string;
  buildRevision: string;
} {
  const hostname = globalThis.location?.hostname ?? "localhost";
  const local = isLocalhost(hostname);

  const rawUrl = import.meta.env.VITE_SUPABASE_URL?.trim() ||
    (local ? "http://127.0.0.1:54321" : "");
  const rawKey = (
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
    import.meta.env.VITE_SUPABASE_ANON_KEY ||
    (local ? "sb_publishable_12Q-h11y2xjaRa2FpkAYSg_7vZKMsYB" : "")
  ).trim();

  if (!rawUrl) {
    throw new Error("Missing DBVDW frontend configuration: VITE_SUPABASE_URL.");
  }
  if (!rawKey) {
    throw new Error(
      "Missing DBVDW frontend configuration: publishable Supabase key.",
    );
  }
  if (rawKey.includes("service_role") || rawKey.startsWith("sb_secret_")) {
    throw new Error(
      "Security violation: a server secret cannot be used in the browser.",
    );
  }

  const parsed = new URL(rawUrl);
  if (parsed.username || parsed.password || parsed.search || parsed.hash) {
    throw new Error(
      "VITE_SUPABASE_URL may not contain credentials, query parameters or fragments.",
    );
  }
  if (!isLocalhost(parsed.hostname) && parsed.protocol !== "https:") {
    throw new Error("Non-local Supabase endpoints must use HTTPS.");
  }

  return {
    supabaseUrl: parsed.origin + parsed.pathname.replace(/\/$/, ""),
    publishableKey: rawKey,
    environment: import.meta.env.VITE_DBVDW_ENVIRONMENT || import.meta.env.MODE,
    buildRevision: import.meta.env.VITE_BUILD_REVISION || "development",
  };
}

export const appConfig = Object.freeze(requirePublicConfig());

export function getFunctionUrl(
  functionName: string,
  pathAndQuery = "",
): string {
  if (!/^[a-z0-9_-]+$/i.test(functionName)) {
    throw new Error(`Invalid function name: ${functionName}`);
  }
  let suffix = pathAndQuery.trim();
  if (suffix && !suffix.startsWith("/") && !suffix.startsWith("?")) {
    suffix = `/${suffix}`;
  }
  return `${appConfig.supabaseUrl}/functions/v1/${functionName}${suffix}`;
}
